import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import LogoImage from '../common/LogoImage';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onChange = e => {
    setEmail(e.target.value);
  };

  const onSubmit = async e => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const res = await axios.post('/api/auth/forgot-password', { email });
      setMessage(res.data.msg);
      setIsSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.msg || 'Failed to process your request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#FFFAFA',
      padding: '20px'
    },
    logo: {
      marginBottom: '30px',
      maxWidth: '400px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
      padding: '30px',
      width: '100%',
      maxWidth: '450px'
    },
    title: {
      color: '#243444',
      textAlign: 'center',
      marginBottom: '20px',
      fontWeight: 'bold'
    },
    alert: {
      backgroundColor: '#f8d7da',
      color: '#721c24',
      padding: '10px',
      borderRadius: '4px',
      marginBottom: '20px'
    },
    success: {
      backgroundColor: '#d4edda',
      color: '#155724',
      padding: '10px',
      borderRadius: '4px',
      marginBottom: '20px'
    },
    formGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      marginBottom: '5px',
      color: '#4C5454',
      fontWeight: 'bold'
    },
    input: {
      width: '100%',
      padding: '10px',
      borderRadius: '4px',
      border: '1px solid #ddd',
      fontSize: '16px'
    },
    button: {
      width: '100%',
      padding: '12px',
      backgroundColor: '#243444',
      color: '#D2BA7B',
      border: 'none',
      borderRadius: '4px',
      fontSize: '16px',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'background-color 0.3s'
    },
    buttonHover: {
      backgroundColor: '#1a2733'
    },
    link: {
      color: '#243444',
      textDecoration: 'none',
      fontWeight: 'bold'
    },
    footer: {
      textAlign: 'center',
      marginTop: '20px',
      color: '#4C5454'
    },
    info: {
      marginBottom: '20px',
      lineHeight: '1.6',
      color: '#4C5454'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.logo}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <LogoImage 
            type="transparent" 
            style={{ maxWidth: '100%', height: '150px' }}
          />
          <h2 style={{ color: '#243444', textAlign: 'center', marginTop: '10px' }}>Business Resilience Navigator</h2>
        </Link>
      </div>
      <div style={styles.card}>
        <h1 style={styles.title}>Reset Your Password</h1>
        
        {!isSubmitted ? (
          <>
            <p style={styles.info}>
              Enter your email address below and we'll send you a link to reset your password.
            </p>
            {error && <div style={styles.alert}>{error}</div>}
            <form onSubmit={onSubmit}>
              <div style={styles.formGroup}>
                <label htmlFor="email" style={styles.label}>Email Address</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={onChange}
                  required
                  style={styles.input}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                style={styles.button}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <div style={styles.success}>
            {message}
          </div>
        )}
        
        <p style={styles.footer}>
          <Link to="/login" style={styles.link}>Back to Login</Link>
        </p>
      </div>
      <div style={{ marginTop: '30px', textAlign: 'center', color: '#4C5454', fontSize: '14px' }}>
        <Link to="/" style={{ color: '#243444', textDecoration: 'none', display: 'block', marginBottom: '10px' }}>← Back to Home</Link>
        © {new Date().getFullYear()} Business Resilience Navigator. All rights reserved.
      </div>
    </div>
  );
};

export default ForgotPassword;
